@let preventLogin = $preventLogin();
<!--{}-->

@if(!environment?.production || isSuperUserAndProduction || preventLogin) {
    <div class="shell-top-filler" [class.super-admin]="isSuperUserAndProduction || preventLogin"></div>
}

<side-nav class="modern nav" [toggle]="state?.navExpanded" [state]="state"></side-nav>

<div class="shell" [ngClass]="{expanded: state?.navExpanded}">

    <!-- <div class="shell-top">
        <div id="shell-page-actions-container" class="page-actions-container">
            <ng-container *ngIf="!environment.production">Environment: {{environment.environment}}</ng-container>
        </div>
        <div class="notifications">

        </div>
        <div class="notifications">

            <p-menu #menu [model]="menuItems" [popup]="true" [style]="{'margin-top': '5px'}" appendTo="body"> </p-menu>
            <profile (click)="menu.toggle($event)" [userImageUrl]="state?.user?.image" [userName]="state?.user?.name" [size]="25"></profile>

        </div>
    </div> -->

    @if(!environment?.production || isSuperUserAndProduction || preventLogin) {

        <div class="shell-top" [class.super-admin]="isSuperUserAndProduction || preventLogin">
            @if (preventLogin) {
                ***<span class="environment">User Logins Disabled</span>***&nbsp;|&nbsp;
            }
            <span class="environment">Environment: {{friendlyEnvironment}}</span>&nbsp;|&nbsp;
            <span class="build">({{buildVersion}})</span>
        </div>

        }

        <div class="shell-content">
            <router-outlet #routerOutlet="outlet"></router-outlet>
        </div>


</div>

<confirm />

<p-toast styleClass="wb-toast" [baseZIndex]="10000" [preventOpenDuplicates]="true">
    <ng-template let-message pTemplate="headless" let-closeFn="closeFn">

        @let severity = message.data?.severity ?? message.severity;

        <w-alert [closable]="!message?.sticky" displayStyle="toast" orientation="vertical" [severity]="severity" [summary]="message.summary" [detail]="message.detail" [actions]="message.data?.actions" (close)="closeFn($event)" />

    </ng-template>
</p-toast>